


































import i18n from 'vue-i18n';
import SignUpField from '@/components/Molecules/signup/SignUpField.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import { SignUpStage as SignUpStageType } from '@/types/auth';

export default {
    name: 'SignUpStage',
    components: { SignUpField, CoHeadline, CoText, CoButton },
    props: {
        stage: { type: Object as () => SignUpStageType, required: true },
        values: { type: Object, required: true },
        finalStage: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        canContinue: { type: Boolean, default: false },
    },
    computed: {
        fields() {
            // The BFF supplies keys; sorting here keeps the public form stable if the response is unordered.
            return [...(this.stage.Fields || [])].sort((a, b) => (a.Order || 0) - (b.Order || 0));
        },
    },
};
